import {
  ProjectSettingsQueryContextProvider,
  ProjectSettingsModalsContextProvider,
} from '../contexts';
import { WhatsAppInfobipLocalesContextProvider } from './LocalesList/WhatsAppInfobipLocalesContext';
import { ProjectSettingsPage } from './ProjectSettingsPage';

export const ProjectSettings = () => (
  <WhatsAppInfobipLocalesContextProvider>
    <ProjectSettingsQueryContextProvider>
      <ProjectSettingsModalsContextProvider>
        <ProjectSettingsPage />
      </ProjectSettingsModalsContextProvider>
    </ProjectSettingsQueryContextProvider>
  </WhatsAppInfobipLocalesContextProvider>
);
